import { styled } from '@mui/material/styles';
import { OpenConstructionCostRoot } from '@/components/Approval/@components/OpenConstructionCost/styles';

/** 레거시 appr_edit_forms_open_construction_cost_settlement — 233 스타일에서 다른 부분만 덮어씀 */
export const OpenConstructionCostSettlementRoot = styled(
  OpenConstructionCostRoot,
)`
  & .info-value.content {
    padding-top: 0;
    padding-bottom: 0;
  }
  & .feasibility-card {
    min-width: 0;
  }
  & .card-note .note-desc {
    white-space: pre-line;
  }
  & .text-left {
    text-align: left;
  }
  & .table th.text-left,
  & .table td.text-left {
    text-align: left;
  }

  /* 투자회수 적정성 카드 내부 2단 컬럼 (투자회수기간 / 이익률) */
  & .roi-cols {
    display: flex;
    gap: 24px;
  }
  & .roi-col {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  & .mini-table .sub {
    color: var(--dk-text-secondary, #888d96);
    font-weight: 400;
  }
  /* 행 간 총액 정렬 */
  & .mini-table .tot {
    display: inline-block;
    width: 148px;
  }
  & .roi-cols .mini-table th,
  & .roi-cols .mini-table td {
    height: calc(24px * 2 + 8px * 2);
  }
  & .card-subtitle {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: var(--dk-text, #000);
  }

  /* 233 공사비 요약 표의 줄바꿈 방지 규칙은 이 양식에 없음 */
  & .budget-table th:nth-child(5),
  & .budget-table td:nth-child(5),
  & .budget-table th:nth-child(6),
  & .budget-table td:nth-child(6) {
    white-space: normal;
  }

  @media screen and (max-width: 990px) {
    & .roi-cols {
      flex-direction: column;
    }
  }
  @media screen and (max-width: 767px) {
    & .mini-table .slash {
      display: none;
    }
    & .mini-table .tot {
      display: block;
      margin-left: auto;
    }
  }
`;
